import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f4e97e7a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "news-console"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "banner"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "新闻动态")], -1));
const _hoisted_3 = {
  class: "operation"
};
const _hoisted_4 = {
  class: "main"
};
const _hoisted_5 = {
  class: "list"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "center"
}, [/*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "各地纷纷发布商业遥感卫星星座计划"), /*#__PURE__*/_createElementVNode("p", {
  class: "text"
}, " “人做、天看、网管，说的就是遥感在看。遥感好像听起来很神秘，说穿了就是眼睛的延长，把眼睛放到更高的地方去，可以看到地面 ")], -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "time"
}, "2023-03-28", -1));
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "dialog-footer"
};
import { ref, reactive } from 'vue';
import img from '@/assets/home/news-1.png';
import { ElMessage } from 'element-plus';
import { Plus } from '@element-plus/icons-vue';
import api from '@/api/api';
export default /*#__PURE__*/_defineComponent({
  __name: 'news-console',
  setup(__props) {
    const form = reactive({
      img: '',
      title: '',
      desc: '',
      time: ''
    });
    const tab = ref('first');
    const page = reactive({
      pageNum: 1,
      pageSize: 5,
      total: 0
    });
    const dialogShow = ref(false);
    const loading = ref(false);
    const tabClick = tab => {};
    const handleSizeChange = size => {};
    const handleCurrentChange = num => {};
    const tableData = ref([]);
    const handleClose = done => {
      dialogShow.value = false;
    };
    // 添加新闻
    const clickAddBtn = () => {
      dialogShow.value = true;
    };
    // 保存新闻
    const clickSaveBtn = async () => {
      const res = await api.addNews({
        title: form.title,
        abstractText: form.desc,
        images: form.img,
        // publishTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        publishTime: form.time
      });
      if (res.code === 0) {
        console.log(res);
        ElMessage.success('保存成功');
      } else {
        ElMessage.error(res.msg);
      }
    };
    const handleAvatarSuccess = (response, uploadFile) => {
      form.img = URL.createObjectURL(uploadFile.raw);
    };
    const beforeAvatarUpload = rawFile => {
      if (rawFile.type !== 'image/jpeg') {
        ElMessage.error('Avatar picture must be JPG format!');
        return false;
      } else if (rawFile.size / 1024 / 1024 > 2) {
        ElMessage.error('Avatar picture size can not exceed 2MB!');
        return false;
      }
      return true;
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
        onClick: clickAddBtn
      }, {
        default: _withCtx(() => [_createTextVNode("新增")]),
        _: 1
      })]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_tabs, {
        class: "tabs",
        modelValue: tab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => tab.value = $event),
        onTabClick: tabClick
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "新闻资讯",
          name: "first"
        }, {
          default: _withCtx(() => [_createElementVNode("ul", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableData.value, (item, index) => {
            return _openBlock(), _createElementBlock("li", {
              key: index,
              class: "item"
            }, [_createElementVNode("b", {
              class: "img bak",
              style: _normalizeStyle(`background-image: url(${_unref(img)})`)
            }, null, 4), _hoisted_6, _hoisted_7]);
          }), 128))])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_pagination, {
        class: "pagination",
        "current-page": page.pageNum,
        "onUpdate:current-page": _cache[1] || (_cache[1] = $event => page.pageNum = $event),
        "page-size": page.pageSize,
        "onUpdate:page-size": _cache[2] || (_cache[2] = $event => page.pageSize = $event),
        "page-sizes": [5, 10, 20, 30],
        small: false,
        disabled: false,
        layout: "total, sizes, prev, pager, next, jumper",
        total: page.total,
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "total"])]), _createVNode(_component_el_dialog, {
        modelValue: dialogShow.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => dialogShow.value = $event),
        title: "新增",
        width: "30%",
        "before-close": handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_9, [_createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = $event => dialogShow.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: clickSaveBtn
        }, {
          default: _withCtx(() => [_createTextVNode(" 保存 ")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: form,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "图片"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_upload, {
              class: "avatar-uploader",
              action: "http://192.168.100.203:9000/apis/api-bigscreen/website/news/upload",
              "show-file-list": false,
              "on-success": handleAvatarSuccess,
              "before-upload": beforeAvatarUpload
            }, {
              default: _withCtx(() => [form.img ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: form.img,
                class: "avatar"
              }, null, 8, _hoisted_8)) : (_openBlock(), _createBlock(_component_el_icon, {
                key: 1,
                class: "avatar-uploader-icon"
              }, {
                default: _withCtx(() => [_createVNode(_unref(Plus))]),
                _: 1
              }))]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "标题"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.title,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.title = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "摘要"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.desc,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.desc = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "时间"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.time,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.time = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});